import { render, staticRenderFns } from "./File.vue?vue&type=template&id=7da1c8a3&scoped=true"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"
import style0 from "./File.vue?vue&type=style&index=0&id=7da1c8a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da1c8a3",
  null
  
)

export default component.exports